import { stdObject } from "../../../data/types/stdObject";
import { colors } from "../../../data/colors";
import { deleteInventory } from "../functions/inventory/deleteInventory";
import { saveInventory } from "../functions/inventory/saveInventory";

export const inventoryModal = ({
  t,
  user,
  customUpdate,
  warehouses,
  dispatch,
  modalData,
  windowValues,
  setWindowValues,
  setModalData,
  setMsg,
  setMsg2,
  setModalData2,
  closeMsg,
  logoutAction,
}: stdObject) => {
  const validateInventory = () => {
    let msg = "";
    if (windowValues.ARTINV[0] === "") {
      msg = "p.enterACode";
    } else if (windowValues.ACTINV === "") {
      msg = "p.enterCurrentStock";
    } else if (windowValues.DISINV === "") {
      msg = "p.enterAvailableStock";
    } else if (Number(windowValues.DISINV) > Number(windowValues.ACTINV)) {
      msg = "p.availableCantExceedCurrent";
    }
    if (msg !== "") {
      setMsg2("custom2");
      setModalData2({ code: "warning", label: t(msg) });
    }
    return msg === "";
  };

  const savePack = {
    t,
    user,
    customUpdate,
    modalData,
    windowValues,
    setWindowValues,
    setModalData,
    setMsg,
    setMsg2,
    closeMsg,
    logoutAction,
  };

  return {
    title: modalData.title,
    mainColor: modalData.mainColor,
    blocked: true,
    inputListStyle: { height: 270 },
    inputs: modalData.inputs?.map((e: stdObject) => {
      return {
        code: e.code,
        label: e.label,
        value:
          e.code === "ALMINV"
            ? warehouses.find(
                (v: stdObject) => v.CODALM === Number(windowValues[e.code]),
              )?.NOMALM
            : e.code === "ARTINV"
              ? Array.isArray(windowValues.ARTINV) &&
                windowValues[e.code].length === 2 &&
                windowValues[e.code][0] !== ""
                ? windowValues[e.code].join(" - ")
                : t("p.search")
              : windowValues[e.code],
        type: e.type,
        options: e.options,
        style: e.style,
        quickData:
          e.type === "innerButton"
            ? {
                search: true,
                type: "ART",
              }
            : {},
        innerStyle: {
          ...e.innerStyle,
          backgroundColor:
            e.code === "ARTINV"
              ? Array.isArray(windowValues.ARTINV) &&
                windowValues.ARTINV.length === 2 &&
                windowValues.ARTINV[0].length > 0
                ? colors.lightGreen
                : colors.lightGrey
              : colors.white,
        },
        onChange: (v: stdObject) => {
          const value =
            e.type === "innerButton" ? [v.CODART, v.NOMART] : v.target.value;
          let tempValues = windowValues;
          tempValues[e.code] = value;
          if (e.code === "ACTINV") {
            tempValues.DISINV = value;
          }
          setWindowValues({ ...tempValues });
        },
      };
    }),
    buttons: [
      {
        label: modalData.id === "" ? t("p.create") : t("p.save"),
        onClick: () => validateInventory() && saveInventory(false, savePack),
        color: colors.green,
      },
      modalData.id === "" && {
        label: t("p.createAndNew"),
        onClick: () => validateInventory() && saveInventory(true, savePack),
        color: colors.orange,
      },
      modalData.id > 0
        ? {
            label: t("p.delete"),
            onClick: () =>
              deleteInventory(false, {
                t,
                customUpdate,
                windowValues,
                setWindowValues,
                modalData,
                setModalData2,
                setMsg2,
                closeMsg,
                logoutAction,
              }),
            color: colors.red,
          }
        : null,
      {
        label: t("p.cancel"),
        onClick: closeMsg,
        color: colors.darkGrey,
      },
    ],
  };
};
